import { Components, Theme } from '@mui/material';

export const MuiTabs: Components<Omit<Theme, 'components'>>['MuiTabs'] = {
  styleOverrides: {
    root: () => ({
      height: 'auto',
      minHeight: 'auto',
    }),
    flexContainer: ({ theme }) => ({
      gap: theme.spacing(0),
    }),
    indicator: {
      display: 'none',
    },
  },
};

export const MuiTab: Components<Omit<Theme, 'components'>>['MuiTab'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      padding: `${theme.spacing(1)} ${theme.spacing(2.5)}`,
      minWidth: 0,
      textTransform: 'initial',
      height: '2.6rem',
      minHeight: '2.6rem',
      borderRadius: theme.spacing(8),
      transition: 'background 200ms, color 200ms',
      color: theme.palette.text.secondary,
      fontSize: theme.typography.buttonSmall.fontSize,
      fontWeight: theme.typography.buttonSmall.fontWeight,
      lineHeight: theme.typography.buttonSmall.lineHeight,
      '&:hover': {
        color: theme.palette.text.primary,
        background: theme.palette.grey[100],
      },

      '&.Mui-selected': {
        background: theme.palette.primaryExtended.opacityBackgroundBackground,
        color: theme.palette.primaryExtended.opacityBackgroundText,
        borderColor: 'transparent',
      },
    }),
    iconWrapper: {
      padding: 0,
    },
    labelIcon: {
      minHeight: '2.6rem',
      height: '2.6rem',
    },
  },
  defaultProps: {
    disableRipple: true,
    disableFocusRipple: true,
    disableTouchRipple: true,
  },
};
